//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
/** Components */
import { ADM_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import useDelete from '../../../../hooks/useDelete';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'AiDocumentManager';

function ADM_BASICF() {
  //#region 변수
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  // 유저정보 배열로 구성되어 있어 첫 번재 요소 가져오도록 사용함 후에 지워야 할 수도 있음

  //#region 그리드 변수
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const [currentRowIndex1, setCurrentRowIndex1] = useState(null);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const [files, setFiles] = useState([]);
  const gridRef1 = useRef(); // 보이스 체크 그리드

  // Tooltip 관련 변수
  const [tooltipInfo, setTooltipInfo] = useState({
    show: false,
    x: 0,
    y: 0,
    content: '',
  });
  const handleCellMouseOver = (e) => {
    if (e.value) {
      setTooltipInfo({
        show: true,
        x: e.event.clientX,
        y: e.event.clientY,
        content: e.value,
      });
    }
  };

  const handleCellMouseOut = () => {
    setTooltipInfo({ ...tooltipInfo, show: false });
  };

  // 파일 input 변수
  const fileInputRef = useRef();
  const [isDragging, setIsDragging] = useState(false);

  //#region 처리결과 변수
  const [resultSummary, setResultSummary] = useState({
    total: 0,
    success: 0,
    fail: 0,
    successRate: 0,
    failRate: 0,
    time: '0분 0초',
    isProcessing: false, // 진행중 여부
    progressRate: 0, // 진행률 %
  });

  // 처리결과 재조회 변수
  const [countdown, setCountdown] = useState(30); // 10초 카운트다운
  const timerRef = useRef(null); // interval 저장용
  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    let intervalId;

    if (resultSummary.isProcessing) {
      const start = dayjs(resultSummary.startDate);

      intervalId = setInterval(() => {
        const now = dayjs();
        const diffMs = now.diff(start);

        const minutes = Math.floor(diffMs / 1000 / 60);
        const seconds = Math.floor((diffMs / 1000) % 60);

        setResultSummary((prev) => ({
          ...prev,
          time: `${minutes}분 ${seconds}초`,
        }));
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [resultSummary.isProcessing, resultSummary.startDate]);

  const startTimer = () => {
    // 이미 타이머가 돌고 있으면 중복 실행 방지
    if (timerRef.current) return;

    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          SearchLogic1(); // 30초마다 재조회 호출
          return 30; // 타이머 초기화
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleManualRefresh = () => {
    clearTimer(); // 이전 타이머 제거
    setCountdown(30); // ✅ 카운트다운 시간 초기화
    SearchLogic1(); // 수동 재조회
    startTimer(); // 타이머 재시작
  };
  //#endregion

  const getDeletePayload1 = (rows) =>
    rows.map((row) => ({
      procedureName: 'SP_ADM_BASIC_D1',
      _CUST_CD: Commons.EncryptAES(row.custCd) || '', //사업장코드
      _AI_MESSAGE_CD: Commons.EncryptAES(row.AI_MESSAGE_CD) || '', //보이스 체크 코드
    }));

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    getDeletePayload: getDeletePayload1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  //조회조건
  // const searchRef = useRef({
  //   custList: custInfo.map((item) => ({
  //     value: item.CUST_CD,
  //     name: item.CUST_NM,
  //   })),
  //   custCd: custInfo?.[0]?.CUST_CD ?? null,
  //   searchText: '',
  // });

  const searchRef = useRef({
    coList: [],
    coCd: '',
    custList: [],
    custCd: '',
  });

  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ searchRef, requireCompany: true, requireCust: true });

  useEffect(() => {
    Init();

    startTimer();

    return () => {
      clearTimer();
    };
  }, []);

  //#endregion
  const Init = async () => {
    await SearchLogic1();
  };

  //#region 조회
  // 그리드 및 RPA 처리결과 조회
  const SearchLogic1 = async () => {
    // setRowData1([]);
    ResetLogic1();

    if (!validateSelection()) return; // 회사/사업장 정보 체크

    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_ADM_BASIC_R1',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', // 사업장코드 OR 사업장명
            // _searchText: Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data.length == 0) {
          // ✅ resultSummary 초기화
          setResultSummary({
            total: 0,
            success: 0,
            fail: 0,
            successRate: 0,
            failRate: 0,
            time: '0분 0초',
            isProcessing: false,
            progressRate: 0,
          });

          dispatch(
            showSnackbar({
              message:
                lanInfo.length === 0
                  ? ''
                  : lanInfo.find(
                      (f) => f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'NotData'
                    ).LAN_NM,
              type: 'info',
            })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          setRowData1(Commons.InsertNumber(data));

          resultSummaryCal(data);
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  // AIDOC_CD 생성 및 반환
  const SearchLogic2 = async () => {
    try {
      const searchResult = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_ADM_BASIC_R2',
          },
        ]
      );

      if (!searchResult?.data?.length) {
        dispatch(
          showSnackbar({
            message: '오류 발생, 작업자에게 문의해 주세요.',
            type: 'info',
          })
        );
        return null; // 또는 undefined
      }

      return searchResult.data[0]?.AIDOC_CD; // ✅ 이렇게만!
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return null; // 실패 시에도 명시적 반환
    }
  };
  //#endregion

  //#region 저장
  // 파일 정보 DB에 저장 { _value1 : AIDOC_CD }
  const SaveLogic1 = async (_value1) => {
    try {
      const saveData = files.map((file) => ({
        procedureName: 'SP_ADM_BASIC_U1',
        _AIDOC_CD: Commons.EncryptAES(_value1) || '',
        _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '',
        _FILE_NAME: Commons.EncryptAES(file.name) || '',
        _USER_ID: userInfo?.userid || '',
      }));

      const result = await Commons.Axios(
        'post1',
        Global.base.useUrl + Global.urls.Execute.execute,
        saveData
      );

      const data = result.data;

      if (!data?.length) {
        // 에러 로그 저장
        const errorMsg = '저장 후 반환된 값이 없습니다.';
        await SaveActionLog({ logResult: 'ERROR', errorMsg: errorMsg });

        dispatch(
          showSnackbar({
            message: errorMsg,
            type: 'error',
          })
        );
        return false;
      }

      // ✅ 모든 결과가 TYPE === 'OK' 인지 검사
      const allSuccess = data.every((item) => item.TYPE === 'OK');

      if (!allSuccess) {
        const errorMsg =
          data.find((item) => item.TYPE !== 'OK')?.message ||
          '에러가 발생했습니다.';

        // 에러 로그 저장
        await SaveActionLog({ logResult: 'ERROR', errorMsg: errorMsg });

        dispatch(
          showSnackbar({
            message: errorMsg,
            type: 'error',
          })
        );
        return false;
      }

      // ✅ 전부 OK일 경우
      // 성공 로그 저장
      await SaveActionLog({ logResult: 'SUCCESS' });

      return true;
    } catch (e) {
      // 에러 로그 저장
      await SaveActionLog({ logResult: 'ERROR', errorMsg: e.message });

      console.error(e);
      dispatch(
        showSnackbar({
          message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
          type: 'error',
        })
      );
      return false;
    }
  };

  // RPA 메일 보내기 메인 로직
  const SendOutLookMail = async () => {
    setLoading(true);

    // 1. AIDOC_CD 생성 및 반환
    const AIDOC_CD = await SearchLogic2();

    if (!AIDOC_CD) return;

    // 2. 파일 정보 DB에 저장
    const saveValid = await SaveLogic1(AIDOC_CD);

    if (!saveValid) return;

    // 3. RPA 메일 보내기
    try {
      const userId = Commons.DecryptoAES(userInfo.userid);
      const userNm = userInfo.userNm;
      const gubun =
        Global.base.useUrl === 'https://devmanagerlv.com:51000/'
          ? 'Dev'
          : 'Prod';

      const formData = new FormData();
      formData.append('to', 'blunex@outlook.com');
      formData.append('from', 'contact@blunex.co.kr');
      formData.append('password', 'jh011023!!');
      formData.append('subject', '위험성평가');
      formData.append(
        'body',
        `
          <p>사업장코드 : ${searchRef.current.custCd}</p>
          <p>AI문서코드 : ${AIDOC_CD}</p>
          <p>USER_ID : ${userId}</p>
          <p>USER_NM : ${userNm}</p>
          <p>구분 : ${gubun}</p>
        `.trim()
      );

      files.forEach((file) => {
        formData.append('attachments', file);
      });

      const result = await Commons.Axios(
        'file',
        Global.base.useUrl + Global.urls.Execute.sendOutlookMail,
        formData
      );

      const data = result?.data;

      if (data && data[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return false;
      }

      await SearchLogic1();

      return true;
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: '메일 전송 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return false;
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const SaveActionLog = async ({ logResult = 'SUCCESS', errorMsg = '' }) => {
    const coCdSafe = userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd;
    const userIdSafe = userInfo.userid;
    const menuIdSafe = SCREEN_MENU_ID || '';

    const actionType = 'INSERT';

    try {
      const payload = [
        {
          _MENU_ID: Commons.EncryptAES(menuIdSafe),
          _CO_CD: Commons.EncryptAES(coCdSafe),
          _USER_ID: userIdSafe,
          _ACTION_RESULT: Commons.EncryptAES(logResult), // SUCCESS/ERROR 또는 ''
          _ACTION_TYPE: Commons.EncryptAES(actionType), // INSERT/UPDATE/DELETE 또는 ''
          _ERROR_MSG: Commons.EncryptAES(errorMsg), // 에러 메시지 또는 ''
        },
      ];

      await Commons.Axios(
        'post',
        `${Global.base.useUrl}${Global.urls.Execute.saveActionLog}`,
        payload
      );
    } catch (e) {
      console.error('❌ SaveActionLog Exception:', e);
    }
  };

  //폼 상태값 리셋 - 그리드
  const ResetLogic1 = () => {
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
  };

  // 시간 차이를 계산하여 "분 초" 형식으로 반환
  const getTimeString = (startDate, endDate = dayjs()) => {
    let diffMs = endDate.diff(startDate);
    if (diffMs < 0) diffMs = 0; // 음수 방지

    const diffMinutes = Math.floor(diffMs / 1000 / 60);
    const diffSeconds = Math.floor((diffMs / 1000) % 60);

    return `${diffMinutes}분 ${diffSeconds}초`;
  };

  // 처리결과 계산 함수
  const resultSummaryCal = async (_data) => {
    const firstItem = _data[0];

    if (firstItem && firstItem.AIDOC_CD) {
      const targetAIDOC_CD = firstItem.AIDOC_CD;

      const relatedItems = _data.filter(
        (item) => item.AIDOC_CD === targetAIDOC_CD
      );

      const total = relatedItems.length;
      const success = relatedItems.filter(
        (item) => item.STATUS === '성공'
      ).length;
      const fail = relatedItems.filter((item) => item.STATUS === '실패').length;
      const inProgress = relatedItems.filter(
        (item) => item.STATUS === '진행중'
      ).length;

      const successRate =
        total > 0 ? Math.round((success / total) * 1000) / 10 : 0;
      const failRate = total > 0 ? Math.round((fail / total) * 1000) / 10 : 0;

      const completed = relatedItems.filter(
        (item) => item.STATUS !== '진행중'
      ).length;
      const progressRate =
        total > 0 ? Math.round((completed / total) * 1000) / 10 : 0;

      const createDate = dayjs(firstItem.CREATE_DATE);
      let timeString = '0분 0초';

      if (inProgress > 0) {
        timeString = getTimeString(createDate); // 진행중이면 현재 시간과 차이
      } else if (firstItem.END_DATE) {
        const endDate = dayjs(firstItem.END_DATE);
        timeString = getTimeString(createDate, endDate); // 완료 시 시작~종료 시간 차이
      }

      setResultSummary({
        total,
        success,
        fail,
        successRate,
        failRate,
        time: timeString,
        isProcessing: inProgress > 0,
        progressRate,
        startDate: createDate,
      });
    }
  };

  /* 이미지 영역 관련 함수 */
  const handleDrop1 = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);

    const extValid = fileExtValid(droppedFiles);
    if (!extValid) return;

    // 모두 엑셀 파일이면 상태 저장
    setFiles(droppedFiles);
  };

  const handleDrop2 = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.target.files);

    const extValid = fileExtValid(droppedFiles);
    if (!extValid) return;

    // 모두 엑셀 파일이면 상태 저장
    setFiles(droppedFiles);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  // 파일 유효성 검사(엑살만 가능하도록)
  const fileExtValid = (_files) => {
    // 허용된 엑셀 확장자 목록
    const allowedExtensions = ['.xls', '.xlsx'];

    // 엑셀이 아닌 파일 필터링
    const invalidFiles = _files.filter((file) => {
      const lowerName = file.name.toLowerCase();
      return !allowedExtensions.some((ext) => lowerName.endsWith(ext));
    });

    if (invalidFiles.length > 0) {
      // 오류 메시지 출력
      dispatch(
        showSnackbar({
          message: '엑셀 파일(.xls, .xlsx)만 업로드할 수 있습니다.',
          type: 'error',
        })
      );
      return false;
    }

    return true;
  };
  //#endregion

  return (
    <div className="wrap">
      <ADM_BASIC
        gridId1={'grid1'}
        userInfo={userInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setCurrentRowIndex1={setCurrentRowIndex1}
        gridRef1={gridRef1}
        fileInputRef={fileInputRef}
        files={files}
        setFiles={setFiles}
        isDragging={isDragging}
        countdown={countdown}
        searchRef={searchRef}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        resultSummary={resultSummary}
        // 회사 사업장
        handleCoChange={handleCoChange}
        validateSelection={validateSelection}
        handleCustChange={handleCustChange}
        // 함수
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        SendOutLookMail={SendOutLookMail}
        handleManualRefresh={handleManualRefresh}
        SearchLogic1={SearchLogic1}
        handleDrop1={handleDrop1}
        handleDrop2={handleDrop2}
        handleDragOver={handleDragOver}
        handleDragEnter={handleDragEnter}
        handleDragLeave={handleDragLeave}
        tooltipInfo={tooltipInfo}
        handleCellMouseOver={handleCellMouseOver}
        handleCellMouseOut={handleCellMouseOut}
      />
      <Loading open={loading} />
    </div>
  );
}

export default ADM_BASICF;
